import { render, staticRenderFns } from "./BonoAlacakForm.vue?vue&type=template&id=38a097ab"
import script from "./BonoAlacakForm.vue?vue&type=script&lang=ts"
export * from "./BonoAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports